export default "__VITE_ASSET__KVRr_tNM__"